import React from 'react';
import { useTranslation } from 'react-i18next';
import gateStyles from './AgentWidgetGate.module.css';

interface AgentWidgetGateSessionErrorProps {
  isSessionInvalid: boolean;
  connectionError: string | null;
  isReconnecting: boolean;
  onReconnect: () => void;
}

export function AgentWidgetGateSessionError({
  isSessionInvalid,
  connectionError,
  isReconnecting,
  onReconnect,
}: AgentWidgetGateSessionErrorProps) {
  const { t } = useTranslation();

  return (
    <div className={gateStyles.errorContainer}>
      <div className={gateStyles.errorIcon}>!</div>
      <h3 className={gateStyles.errorTitle}>
        {isSessionInvalid ? t('agent:session.expiredTitle') : t('agent:session.connectionError')}
      </h3>
      <p className={gateStyles.errorMessage}>
        {isSessionInvalid ? t('agent:session.expiredMessage') : connectionError}
      </p>
      {isSessionInvalid ? (
        <button
          type="button"
          className={gateStyles.retryButton}
          onClick={onReconnect}
          disabled={isReconnecting}
        >
          {isReconnecting ? t('agent:session.reconnecting') : t('agent:session.reconnect')}
        </button>
      ) : (
        <button
          type="button"
          className={gateStyles.retryButton}
          onClick={() => window.location.reload()}
        >
          {t('common:buttons.retry')}
        </button>
      )}
    </div>
  );
}
